import { AdminService } from '../../../_services/admin.service';


import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subscription-group-show',
  templateUrl: './subscription-group-show.component.html',
  styleUrls: ['./subscription-group-show.component.css']
})
export class SubscriptionGroupShowComponent implements OnInit {
  subscriptionGroup:any = undefined
  loading=false
  server_user_id=0

  constructor(private activatedRoute:ActivatedRoute, private adminService:AdminService, private router:Router) { }

  ngOnInit(): void {
    this.loading=true
    this.activatedRoute.params.subscribe(
      params =>{
        this.server_user_id=params['server_user_id']
        this.adminService.getSubscriptionGroup(params['server_subscription_group_id']).subscribe(
          sG=>{
            this.subscriptionGroup = sG
            this.loading=false
          }
        )
      }
    )
  }



  createNewGrouping(){
   this.router.navigate(["/batch/grouping/new",this.subscriptionGroup.server_subscription_group_id,0])
  }
}
